import { render, staticRenderFns } from "./VendorGroupsTable.vue?vue&type=template&id=9c76184e&"
import script from "./VendorGroupsTable.vue?vue&type=script&lang=js&"
export * from "./VendorGroupsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports